import React from "react";
import Show from "../../../utils/show.component";

export const AuthRecurringValidationDisplay = ({ recurringValidation }) => {
  const message = recurringValidation.ValidationMessage;
  const loading = recurringValidation.loading;

  const borderAndTextColor = recurringValidation.IsValid || loading ? "#00558C" : "#d52c27";
  const backgroundColor =
    recurringValidation.IsValid || loading ? "rgba(0, 89, 140, .1)" : "rgba(213, 44, 39, .1)";

  return (
    <Show condition={message || loading}>
      <div
        className="p-3 mt-2"
        style={{
          border: "2px solid " + borderAndTextColor,
          backgroundColor: backgroundColor,
          color: borderAndTextColor,
          borderRadius: "5px",
        }}
      >
        {message && <div className="f14">{message}</div>}
        {loading && (
          <div
            className="circle-loader m-auto"
            style={{
              width: "3em",
              height: "3em",
              display: "flex",
              borderLeftColor: borderAndTextColor,
            }}
          />
        )}
      </div>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/auth-recurring-validation-display.component.js